// extracted by mini-css-extract-plugin
export var divider = "_wg-0";